export class RoleDto {
  constructor(
    public name: string,
    public description: string,
  ) {}
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dto/role.dto.ts